import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { DownloadJpg } from '../../../../common/downloadJpg'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Element } from '../../../../common/html/element'
import { LabelWithIconInfo } from '../../../../common/LabelWithIconInfo'
import { Panel } from '../../../../common/panel'
import { panelTypes } from '../../../../common/panel/constants'
import { SelectCustom } from '../../../../common/selectCustom'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { selectData } from '../businessYears/store/slice'
import { BusinessProvinceMap } from './BusinessProvinceMap'
import { BusinessProvinceTable } from './BusinessProvinceTable'
import { mapViewBy } from './constant'
import { resetStore } from './store/slice'
import {
  downloadBusinessProvince,
  getBusinessProvinceTable,
} from './store/thunk'

export const BusinessProvince = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const label = UseI18n(
    'industryOverview.businessProvince.BUSINESS_BY_PROVINCE',
  )
  const { organizationShortName, organizationName, taxCode, companyType } =
    useSelector(selectCompanyInfo)
  const data = useSelector(selectData)
  const locale = useSelector((state) => state.i18n.locale)
  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const [viewBy, setViewBy] = useState(mapViewBy.map.value)
  const isViewByMap = viewBy === mapViewBy.map.value

  const handleChooseViewBy = (item) => {
    if (item.value !== viewBy) {
      setViewBy(item.value)
    }
  }

  const renderRightHeader = () => {
    return (
      <Element
        className="dFlex alignItemsCenter"
        style={{ color: '#3A414B', marginRight: isViewByMap ? 0 : -16 }}
      >
        <Translate value="financialAnalysis.VIEW_BY" />
        <SelectCustom
          isBorderNone
          isI18n
          activeItem={Object.values(mapViewBy).find(
            (item) => item.value === viewBy,
          )}
          data={Object.values(mapViewBy)}
          chooseItem={handleChooseViewBy}
        />
        {isViewByMap && (
          <DownloadJpg
            data={{
              arrName: [
                label,
                organizationShortName || organizationName || taxCode || '',
              ],
              titleJpg: label,
              domId: 'businessProvinceMapId',
            }}
          />
        )}
      </Element>
    )
  }

  useEffect(() => {
    dispatch(
      getBusinessProvinceTable({
        OrganizationId: organizationId,
      }),
    )
  }, [locale, organizationId])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  return (
    <Panel
      isI18n
      renderLabel={() => (
        <LabelWithIconInfo
          label={'industryOverview.businessProvince.BUSINESS_BY_PROVINCE'}
          renderToolTipContent={() => (
            <Translate value={'industryOverview.businessProvince.TOOLTIP'} />
          )}
        />
      )}
      type={panelTypes.FULL_SIZE}
      downloadCsv={
        isViewByMap
          ? undefined
          : {
              disabled: !Object.keys(data).length,
              downloadFunc: () =>
                downloadBusinessProvince({
                  OrganizationId: organizationId,
                }),
            }
      }
      renderRightHeader={renderRightHeader}
    >
      {isViewByMap ? <BusinessProvinceMap /> : <BusinessProvinceTable />}
    </Panel>
  )
}
